/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { QuestionReference, QuestionReferenceProps } from '../QuestionReference';

interface DataOrNotWrapperProps extends QuestionReferenceProps {
  height?: string | number;
  width?: string | number;
  children: JSX.Element;
}

export const DataOrNotWrapper = (props: DataOrNotWrapperProps) => {

  const Body = () => {
    if (props.showNoData) {
      return (
        <div
          className='chart-or-not-wrapper h-100 w-100'
          style={
            {
              minHeight: `${props.height}px`,
              width: `${props.width}px`,
            }
          }>
          <QuestionReference {...props} showNoData={true} />
        </div>
      );
    }
    return <>
      {props.children}
      <QuestionReference {...props} />
     </> ;
  };

  return (
    <div className='flex-fill d-flex flex-column justify-content-between'>
      <Body />
    </div>
  );
}
